import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { VEHICLE_REMOTE_COMMAND_FIELDS } from './remoteCommandFields';

export const SEND_VEHICLE_REMOTE_COMMAND_MUTATION = `
	mutation sendVehicleRemoteCommand($input: SendVehicleRemoteCommandInput!) {
		RemoteCommand: sendVehicleRemoteCommand(input: $input) {
			${VEHICLE_REMOTE_COMMAND_FIELDS}
		}
	}
`;

/**
 * Sends LOCK_DOOR / UNLOCK_DOOR for one unit (general API, Cognito). The
 * backend dedupes on `clientRequestId`. REJECTED / FAILED rows come back as
 * data (not errors); CONFLICT / UNAUTHORIZED reject with `errorInfo.reason`.
 */
export const sendVehicleRemoteCommand = async ({ unitId, command, clientRequestId }) => {
	const res = await clientMutation(
		SEND_VEHICLE_REMOTE_COMMAND_MUTATION,
		{ input: { unitId: Number(unitId), command, clientRequestId } },
		endpoints.GRAPHQL_GENERAL_V2,
	);
	return res?.RemoteCommand ?? null;
};
